import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const LOGO = "/tytocare-logo.png";

export default function AuthShell({ title, subtitle, children, aside }) {
  return (
    <div className="min-h-screen bg-[#F6F4FA] lg:grid lg:grid-cols-12" data-testid="auth-shell">
      <aside className="relative hidden lg:col-span-5 lg:flex flex-col justify-between overflow-hidden bg-[#1F152E] px-12 py-12 text-white">
        <div className="absolute -right-32 -top-32 h-96 w-96 rounded-full bg-[#5B2C91]/40 blur-3xl" />
        <div className="absolute -bottom-40 -left-20 h-96 w-96 rounded-full bg-[#D4F84A]/10 blur-3xl" />
        <div className="relative">
          <Link to="/" className="inline-flex items-center rounded-2xl bg-white px-3 py-2" data-testid="auth-logo-link">
            <img src={LOGO} alt="TytoCare" className="h-7 w-auto" />
          </Link>
        </div>
        <div className="relative max-w-md">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.2em] text-[#D4F84A]">
            <span className="h-1.5 w-1.5 rounded-full bg-[#D4F84A]" /> Area riservata
          </span>
          <h2 className="font-heading mt-6 text-4xl font-semibold leading-tight">{aside?.title || "La sanità a domicilio, organizzata bene."}</h2>
          <p className="mt-4 text-base text-white/70">{aside?.text || "Gestione di visite, medici, infermieri e disponibilità. I medici decidono i propri orari, i pazienti ricevono risposte immediate su WhatsApp."}</p>
        </div>
        <p className="relative text-xs text-white/40">© {new Date().getFullYear()} TytoCare Italia · Lamoni Lab S.r.l.</p>
      </aside>

      <main className="flex min-h-screen flex-col justify-center px-4 py-10 sm:px-8 lg:col-span-7 lg:px-16">
        <div className="mx-auto w-full max-w-lg">
          <div className="mb-8 flex items-center justify-between lg:hidden">
            <Link to="/"><img src={LOGO} alt="TytoCare" className="h-7 w-auto" /></Link>
            <Link to="/" className="inline-flex items-center gap-1 text-xs font-semibold text-[#5B2C91]" data-testid="auth-back-mobile"><ArrowLeft className="h-3.5 w-3.5" /> Sito</Link>
          </div>
          <h1 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight text-[#1F152E]" data-testid="auth-title">{title}</h1>
          {subtitle && <p className="mt-2 text-sm sm:text-base text-[#6B6280]">{subtitle}</p>}
          <div className="mt-8">{children}</div>
        </div>
      </main>
    </div>
  );
}
